
export const mainCardobjects = {


    // ORIGINAL FOOTBALL

    // valentines: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/valentines%2Fvalentines_towo-min.jpg?alt=media&token=6e46e8ac-b2bc-46c0-ba84-68e554cbedf7',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Valentines Offers',
    //     itemType: 'template',
    //     fullDescription: 'Choose from our selection of Valentines Offers',
    //     shortDescriptions: '35,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'couples',
    //     objectKey: "couples"
    // },
 


    // football: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fcranes.png?alt=media&token=0f658820-647a-45c6-8077-f489e17b1cb8',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Uganda Cranes Jersey',
    //     itemType: 'cranes',
    //     fullDescription: 'Get a customized Uganda Cranes Shirt',
    //     shortDescriptions: '40,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: false,
    //     // templateType: 'cranes',
    //     objectKey: "cranes"
    // },

    t_shirts: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Ft_shirts_new-min.jpg?alt=media&token=b6c2f84d-f9fe-4e9d-b622-cd405547949b',
        imageSize: 'massive',
        itemTypeDescription: 'Custom T-Shirts',
        itemType: 't-shirts',
        fullDescription: 'Create your own custom T-Shirt',
        shortDescriptions: '45,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        //  templateType: 'football',
        objectKey: "t_shirts"
    },


    phoneCase: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fcustomized_phone_case_600-min.jpg?alt=media&token=0731003b-b14d-4bcd-94c2-e4037f378ee6',
        imageSize: 'massive',
        itemTypeDescription: 'Custom Phone case',
        itemType: 'phoneCase',
        fullDescription: 'Create your own custom Phone Case',
        shortDescriptions: '40,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "phoneCase"
    },

    jumper: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Ftrisha_jumper_mukiga_600.jpg?alt=media&token=713bb324-a5b9-4725-896b-9f0afb02054e',
        imageSize: 'massive',
        itemTypeDescription: 'Custom Jumpers',
        itemType: 'jumper',
        fullDescription: 'Create your own custom Jumper',
        shortDescriptions: '65,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "jumper"
    },

    storageBoxes: {
        image: 'https://s3.eu-central-1.amazonaws.com/printbaimages/home.jpg',
        imageSize: 'massive',
        itemTypeDescription: 'Kitenge Mini Storage Boxes',
        itemType: 'storageBoxes',
        fullDescription: 'Get these mini storage boxes',
        shortDescriptions: '25,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "storageBoxes"
    },

    faceShirt: {
        image: 'https://s3.eu-central-1.amazonaws.com/printbaimages/faceShirt.jpg',
        imageSize: 'massive',
        itemTypeDescription: 'Cartoon / Face T-shirt',
        itemType: 'template',
        fullDescription: 'Upload A Pic to convert it to art',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'faceShirt',
        objectKey: "faceShirt"
    },

    enter_birthday: {
        image: 'https://s3.eu-central-1.amazonaws.com/printbaimages/enter_birthday.jpg',
        imageSize: 'massive',
        itemTypeDescription: 'Customized Birthday Gifts',
        itemType: 'template',
        fullDescription: 'Create Customized Birthday Gifts',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'enter_birthday',
        objectKey: "enter_birthday"
    },

    intimate: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fintimate%2Fthong600-min.jpg?alt=media&token=8f50cddd-83cf-4a98-aba4-d41e547ce593',
        imageSize: 'massive',
        itemTypeDescription: 'Intimate Wear',
        itemType: 'template',
        fullDescription: 'Choose from our selection of Intimate items',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'intimate',
        objectKey: "intimate"
    },

    robe: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Frobes%2FRobesMainSqaure_600-min.jpg?alt=media&token=50ee81f6-64f3-41b2-872a-a5899524c0bb',
        imageSize: 'massive',
        itemTypeDescription: 'Customized Robes',
        itemType: 'template',
        fullDescription: 'Get a customized robe',
        shortDescriptions: '95,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'robe',
        objectKey: "robe"
    },

    jacket: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/jacket%2FjacketSquareNeck_600.jpg?alt=media&token=89aed401-cd09-4d08-a757-ac1a4ab5d90c',
        imageSize: 'massive',
        itemTypeDescription: 'Mens Jacket',
        itemType: 'jacket',
        fullDescription: 'Get this mens jacket',
        shortDescriptions: '65,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "jacket"
    },

    // couples: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fcouples%2Fvalentines_BoyKissingShirtCombinedSMALL.jpg?alt=media&token=090b30c9-e04c-4a50-adef-e407db145229',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Couples',
    //     itemType: 'template',
    //     fullDescription: 'Choose from our selection of couples t-shirts',
    //     shortDescriptions: '35,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'couples',
    //     objectKey: "couples"
    // },

    clock: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fclock%2FclockMainSqure_600-min.jpg?alt=media&token=8a3735cb-18fe-4785-bb88-78ecd434946f',
        imageSize: 'massive',
        itemTypeDescription: 'Wall Clock',
        itemType: 'clock',
        fullDescription: 'Get a customized wall clock',
        shortDescriptions: '85,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "clock"
    },

    bracelet: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fbracelet%2FbraceletMainSquare_three_600.jpg?alt=media&token=124b9945-3ebd-4af7-9051-74a5d2f2e525',
        imageSize: 'massive',
        itemTypeDescription: 'Bracelet',
        itemType: 'bracelet',
        fullDescription: 'Get a pair of customized bracelet',
        shortDescriptions: '25,000 UGX FOR (2)',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "bracelet"
    },

 
    cap: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fhat550_min.jpg?alt=media&token=ea8e18e8-4ffb-49ce-a2b4-766d037d2436',
        imageSize: 'massive',
        itemTypeDescription: 'Caps',
        itemType: 'cap',
        fullDescription: 'Create your own customized Caps',
        shortDescriptions: '25,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        //templateType: 'cap',
        objectKey: "cap"
    },

    pillow: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2FpillowRedConnorSamantha..jpg?alt=media&token=310a3606-5491-4992-b48a-c6bedbe9a9d6',
        imageSize: 'massive',
        itemTypeDescription: 'Pillows',
        itemType: 'pillow',
        fullDescription: 'Create your own customized Pillows',
        shortDescriptions: '45,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'pillow',
        objectKey: "pillow"
    },

    cup: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2FcupImage_min.06b146b4.jpeg?alt=media&token=5faf3f7e-9fb4-45eb-9eac-29a073abd4ab',
        imageSize: 'massive',
        itemTypeDescription: 'Cups',
        itemType: 'cup',
        fullDescription: 'Create your own custom Cup',
        shortDescriptions: '45,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
       // templateType: 'cup',
        objectKey: "cup"
    },

    baby: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fbaby%2Fbaby600-min.jpg?alt=media&token=382f76e1-61e6-4d0a-afa0-59c6e927cb99',
        imageSize: 'massive',
        itemTypeDescription: 'Baby Items',
        itemType: 'baby',
        fullDescription: 'Choose from our selection of New Born Items',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'baby',
        objectKey: "baby"
    },

    sweat_shirt: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fsweatshirt-light-grey-600-min.jpg?alt=media&token=2c1890e9-cad9-4d44-95a0-4d87531edf04',
        imageSize: 'massive',
        itemTypeDescription: 'Custom Sweatshirts',
        itemType: 'sweat_shirt',
        fullDescription: 'Create your own custom Sweatshirt',
        shortDescriptions: '65,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "sweat_shirt"
    },

    // flag: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fflag%2FFlagBanner_min.jpg?alt=media&token=b3f25cdd-b3bc-4782-b528-441918e61442',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Customized Flag',
    //     itemType: 'flag',
    //     fullDescription: 'Get a customized Flag',
    //     shortDescriptions: '100,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     //template: true,
    //     //templateType: 'flag',
    //     objectKey: "flag"
    // },

    jersey_kit: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2FplainJerseysMain-min.jpg?alt=media&token=3061fb19-1d52-4358-b1e4-b37278960c11',
        imageSize: 'massive',
        itemTypeDescription: 'Create your own Team Jersey',
        itemType: 'template',
        fullDescription: 'Choose from our selection of Plain Jersey Kits',
        shortDescriptions: '45,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'jersey_kit',
        objectKey: "jersey_kit"
    },

    bizpackages: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2FbizPackages%2Ftshirt_jumper_cup-min.jpg?alt=media&token=8ced5bae-058a-4084-babc-2e014461bacb',
        imageSize: 'massive',
        itemTypeDescription: 'Get a custom branding package for your business',
        itemType: 'template',
        fullDescription: 'Get a business branding package',
        shortDescriptions: '105,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'bizpackages',
        objectKey: "bizpackages"
    },

    // wedding: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fwedding%2FWedding_plan-min.jpg?alt=media&token=d588aedd-afd8-4fa9-90c9-1635fa88c67b',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Get a custom wedding shirt',
    //     itemType: 'template',
    //     fullDescription: 'Get a custom wedding shirt',
    //     shortDescriptions: '35,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'wedding',
    //     objectKey: "wedding"
    // },

    // kitenge: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fkitenge%2Futamaduni___Kitenge_Cloth-min.jpg?alt=media&token=60531143-76ec-40f0-84a8-7945f0fb835c',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Kitenge',
    //     itemType: 'template',
    //     fullDescription: 'Choose from our shirts and jumpers with a touch of kitenge!',
    //     shortDescriptions: '45,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'Kitenge',
    //     objectKey: "Kitenge"
    // },



    plainShirts: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fblank_white_shirt.jpg?alt=media&token=a73d4d06-f7e4-4fe5-8f52-cf5a5d75c5c5',
        imageSize: 'massive',
        itemTypeDescription: 'Plain Shirts',
        itemType: 'template',
        fullDescription: 'Choose from our selection of Plain t-shirts',
        shortDescriptions: '25,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'plainShirts',
        objectKey: "plainShirts"
    },

 

    vest: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fvest550-min.jpg?alt=media&token=ffa61fb1-af2d-45c3-85a9-1d8c755d9809',
        imageSize: 'massive',
        itemTypeDescription: 'Vests',
        itemType: 'vest',
        fullDescription: 'Create your own custom Vest',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'vest',
        objectKey: "vest"
    },

    straight_outta: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fstraight_outta_custom_text-min.jpg?alt=media&token=09cf72da-2883-45a3-b86e-9ee746e60801',
        imageSize: 'massive',
        itemTypeDescription: 'Show Your Heritage',
        itemType: 'template',
        fullDescription: 'Customize a shirt with the place ur proud of',
        shortDescriptions: '35,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'straight_outta',
        objectKey: "straight_outta"
    },

    packages: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fpackage_template_square.dcb2920d.jpg?alt=media&token=0147b635-5cf0-4f3d-8d71-53535e5cf87e',
        imageSize: 'massive',
        itemTypeDescription: 'Custom Birthday Packages',
        itemType: 'template',
        fullDescription: 'Select from one of our birthday packages!',
        shortDescriptions: '105,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: true,
        templateType: 'packages',
        objectKey: "packages"
    },

    // eplJumpers: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/football%2FteamHoodies%2Fmanu%20hoodie-min.jpg?alt=media&token=7f1e654b-e749-4222-8b76-9fd1d490932f',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Epl Jumpers',
    //     itemType: 'template',
    //     fullDescription: 'Get your a Football jumpers',
    //     shortDescriptions: '60,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'eplJumpers',
    //     objectKey: "eplJumpers"
    // },

    keychain: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/keychain%2FblankKeyChain.jpg?alt=media&token=d5a950c0-0647-41f9-bb6d-2927681242b8',
        imageSize: 'massive',
        itemTypeDescription: 'Custom Keychain',
        itemType: 'keychain',
        fullDescription: 'Create your own custom Key chain',
        shortDescriptions: '25,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'jumper',
        objectKey: "keychain"
    },



    // success: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/templates%2Fsuccess%2FGraduation-Package_600-min.jpg?alt=media&token=efc0d8f6-ef0c-4218-963f-38aaa578abab',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Wish Success',
    //     itemType: 'template',
    //     fullDescription: 'Wish A Student Success',
    //     shortDescriptions: '60,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'success',
    //     objectKey: "success"
    // },


    // eplStore_arsenal: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/eplStores%2Farsenal%2Farsenal_cups_polos_600-min.jpg?alt=media&token=bb5c2cd1-65c9-45a4-b485-b07d05f20e27',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Arsenal Shop',
    //     itemType: 'template',
    //     fullDescription: 'Create your own customized Arsenal Gear',
    //     shortDescriptions: '40,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'eplStore_arsenal',
    //     objectKey: "eplStore_arsenal"
    // },

    // eplStore_manu: {
    //     image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/eplStores%2Fmanu%2Fmanu_jersey_cap_600.jpg?alt=media&token=f4f5fe51-fd61-4b88-92e4-7ed5f19feb59',
    //     imageSize: 'massive',
    //     itemTypeDescription: 'Manchester United Shop',
    //     itemType: 'template',
    //     fullDescription: 'Create your own customized Manchester United Gear',
    //     shortDescriptions: '40,000 UGX EA',
    //     //showMainForm: this.props.showMainForm,
    //     template: true,
    //     templateType: 'eplStore_manu',
    //     objectKey: "eplStore_manu"
    // },

    cranes: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fcranes.png?alt=media&token=0f658820-647a-45c6-8077-f489e17b1cb8',
        imageSize: 'massive',
        itemTypeDescription: 'Uganda Cranes Jersey',
        itemType: 'cranes',
        fullDescription: 'Get a customized Uganda Cranes Shirt',
        shortDescriptions: '40,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'cranes',
        objectKey: "cranes"
    },

    football: {
        image: 'https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/football%2FteamJerseys%2Fmanu%2FmanuNewKitsCustomizedcx.jpeg?alt=media&token=feb768ea-6777-4530-8c8a-b828a5240ebb',
        imageSize: 'massive',
        itemTypeDescription: 'Football Jersey',
        itemType: 'football',
        fullDescription: 'Get your own customized football jersey',
        shortDescriptions: '40,000 UGX EA',
        //showMainForm: this.props.showMainForm,
        template: false,
        // templateType: 'football',
        objectKey: "football"
    },


}

export const mainCardOrder = ["3", "7",];


// WEBPACK FOOTER //
// ./src/components/newSite/LandingPageCardsOrdering/MainCardsOrdering.js